import React from 'react'
import { usePlan } from '../../hooks/usePlan'
import { DARMOWY_DOSTEP, PROBA_BEZ_FIRMY } from '../../config/plany'
import OdbierzPremium, { dataPremium } from './OdbierzPremium'

/**
 * Plan konta pod nagłówkiem „Moje konto” (decyzja właściciela 2026-10-19: każde konto przez pierwszy miesiąc wie, że
 * ma Premium). Konto bez firmy nie ma pulpitu z licznikiem, więc to jego główne miejsce z tą informacją.
 * We Free z darmowym dostępem (`DARMOWY_DOSTEP`) od razu przycisk do odebrania kolejnego miesiąca.
 */
const PlanKonta = () => {
  const plan = usePlan()
  if (plan.stan !== 'plan') return null
  const doDnia = plan.premiumDo || plan.probaDo
  if (plan.plan === 'premium') {
    return (
      <p className="m-0 mt-2 inline-flex items-center gap-2 text-sm font-semibold text-gray-900">
        <span className="h-2 w-2 rounded-full bg-blue-600" aria-hidden="true" />
        {plan.firmowe ? 'Firma ma' : 'Masz'} Premium{doDnia ? ` do ${dataPremium(doDnia)}` : ''}
      </p>
    )
  }
  // Konto prywatne bez próby (próba tylko z NIP-em) ma swoje narzędzia za darmo; plan nic mu tu nie mówi.
  if (!plan.firmowe && !PROBA_BEZ_FIRMY) return null
  return (
    <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-2">
      <p className="m-0 inline-flex items-center gap-2 text-sm font-semibold text-gray-900">
        <span className="h-2 w-2 rounded-full bg-amber-400" aria-hidden="true" />Plan Free
      </p>
      {DARMOWY_DOSTEP && <OdbierzPremium />}
    </div>
  )
}

export default PlanKonta
